/*###########################################################################
// App
//#########################################################################*/

/* CSS
//------------------*/

import '@css/app.css'

/* Barba
//------------------*/

import '@js/_barba'

/* App
//------------------*/

window.app = {
  disableScroll() {
    document.documentElement.style.overflow = 'hidden'
  },

  enableScroll() {
    document.documentElement.style.overflow = ''
  },

	handleFOUC() {
		const header = document.querySelector('.header')
		header.style.opacity = ''
		header.style.backgroundColor = ''

		const modals = document.querySelectorAll('.modal')
		for (let i = 0; i < modals.length; i++) {
			const modal = modals[i]
			modal.style.opacity = ''
		}
	}
}

window.app.handleFOUC()

window.addEventListener('page-change', function() {
	window.app.handleFOUC()
})

/* Utilities
//------------------*/

import '@js/utilities/_initComponent'

/* Components
//------------------*/

import '@js/components/index'

/* Vendor
//------------------*/

import '@js/vendor/index'

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}
